// @flow
import _ from 'lodash';
import type { PureComputed } from 'rgs-knockout';
import BaseViewModel from 'rgs-nfd-ui-kit/ko-components/tree/BaseViewModel';
import type {
	ISelectStrategy, SelectDefaultItem,
	SelectViewModelOptions,
} from 'rgs-nfd-ui-kit/ko-components/select/index.flow';
import { SelectBaseStrategy } from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import type { ComponentInfo } from 'rgs-knockout/types';

export class SelectViewModel<TItem:* | SelectDefaultItem>
	extends BaseViewModel<SelectViewModelOptions<TItem>> {

	_options: $NonMaybeType<SelectViewModelOptions<TItem>>;

	currentValue: PureComputed<TItem>;
	onClickLayout: ()=>void;
	onClickCancel: ()=>void;
	onClickItem: (TItem)=>()=>void;

	get strategy (): ISelectStrategy<TItem> {
		return this._options.strategy;
	}

	constructor (
		options: { props: SelectViewModelOptions<TItem> },
		elementContent: ComponentInfo,
	) {
		super(options, elementContent);

		this._options = _.defaults(options.props, {
			strategy: new SelectBaseStrategy(),
		});

		this.onClickLayout = this.strategy.onClickLayout.bind(this.strategy);
		this.onClickCancel = this.strategy.onClickCancel.bind(this.strategy);
		this.onClickItem = (item: TItem) => () => this.strategy.onClickItem(item);

		this.strategy.setElement(this.elementContent.element);
	}
}
